import React from 'react';
import {connect} from 'react-redux';
import {getToken as getTokenAction} from 'actions/betGames/creators';
import WidgetContainer from './BetgamesSidebarWidgetContainer.jsx';
import AuthedSidebarWidgetContainer from './AuthedSidebarWidgetContainer.jsx';

class SidebarWidget extends React.Component {
    componentWillMount() {
        if (this.props.user && this.props.betGames.get('token') === undefined) {
            this.props.getTokenAction();
        }
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.user !== nextProps.user && nextProps.user && nextProps.betGames.get('token') === undefined && nextProps.betGames.get('fetching') === false) {
            this.props.getTokenAction();
        }
    }

    render() {
        const {betGames, user, auth} = this.props;
        return (
            <div className='widget-wrapper'>
                {/* {betGames.get('token') !== undefined && <AuthedSidebarWidgetContainer betGames={betGames} user={user}/>}
                {(user === null && betGames.get('token') === undefined &&
                    (auth.get('isAuthenticating') === false || auth.get('isAuthenticating') === null)) &&
                <WidgetContainer user={user}/>} */}
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        auth: state.auth,
        user: state.auth.get('user'),
        betGames: state.betGames
    }
};

export default connect(mapStateToProps, {getTokenAction})(SidebarWidget);


// WEBPACK FOOTER //
// ./js/sport-betting/components/betgames/SidebarWidget.jsx